import React from "react";
import {
  View,
  Text,
  TouchableOpacity,
  StyleSheet,
  Platform,
  useWindowDimensions,
} from "react-native";
import Svg, { Circle } from "react-native-svg";
import GlobalStyles from "./StylenColor";
import {
  widthPercentageToDP as wp,
  heightPercentageToDP as hp,
} from "react-native-responsive-screen";

const NFProgress = ({ topic, onLongPress }) => {
  const { width } = useWindowDimensions();
  const isDesktopWeb = Platform.OS === "web" && width > 900;
  const size = isDesktopWeb ? wp("9%") : wp("27.2%");
    const strokeWidth = isDesktopWeb ? wp("0.7%") : wp("1.8%");
    const outerRadius = (size - strokeWidth) / 2;
    const innerRadius = isDesktopWeb ? outerRadius - wp("1.2%") : outerRadius -  wp("3.5%");
  

  const outerCircumference = 2 * Math.PI * outerRadius;
  const innerCircumference = 2 * Math.PI * innerRadius;

  return (
    <View
      style={[styles.circularContainer, , isDesktopWeb && { width: "33%" }]}
    >
      <View
        style={[
          { position: "relative", width: size, height: size },
          isDesktopWeb && { marginBottom: hp("1%") },
        ]}
      >
        <Svg width={size} height={size}>
          {/* Outer base */}
          <Circle
            cx={size / 2}
            cy={size / 2}
            r={outerRadius}
            stroke="#fff"
            strokeWidth={strokeWidth}
            fill="none"
          />
          {/* Outer ring */}
          <Circle
            cx={size / 2}
            cy={size / 2}
            r={outerRadius}
            stroke="#e5f4f3"
            strokeWidth={strokeWidth}
            fill="none"
            strokeDasharray={outerCircumference}
            strokeDashoffset={0}
            strokeLinecap="round"
          />
          {/* Inner base */}
          <Circle
            cx={size / 2}
            cy={size / 2}
            r={innerRadius}
            stroke="#fff"
            strokeWidth={strokeWidth}
            fill="none"
          />
          {/* Inner ring */}
          <Circle
            cx={size / 2}
            cy={size / 2}
            r={innerRadius}
            stroke="#e5f4f3"
            strokeWidth={strokeWidth}
            fill="none"
            strokeDasharray={innerCircumference}
            strokeDashoffset={0}
            strokeLinecap="round"
          />
        </Svg>

        {/* Centered NE */}
        <TouchableOpacity
          onLongPress={onLongPress}
          delayLongPress={500}
          style={[
            styles.progressTextContainer,
            { width: size, height: size },
            isDesktopWeb && { alignContent: "center" },
          ]}
        >
          <Text
            style={[
              styles.progressText,
              isDesktopWeb && { fontSize: GlobalStyles.fontSize.xsss - 2 },
            ]}
          >
            NE
          </Text>
        </TouchableOpacity>
      </View>

      {/* Topic label */}
      <View style={styles.topicContainer}>
        <Text
          style={[
            styles.topicText,
            isDesktopWeb && {
              marginTop: 12,
              fontSize: GlobalStyles.fontSize.xs - 2.5,
              marginBottom: hp("2%"),
            },
          ]}
        >
          {topic}
        </Text>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  circularContainer: {
    alignItems: "center",
    justifyContent: "center",
    width: "33%",
    position: "relative",
    marginBottom: 13,
  },
  progressTextContainer: {
    position: "absolute",
    // top: 0,
    // left: 0,
    // right: 0,
    // bottom: 0,
    alignItems: "center",
    justifyContent: "center",
  },
  progressText: {
    fontSize: GlobalStyles.fontSize.xsss,
    fontFamily: GlobalStyles.GlobalFont.fontFamily,
    color: "#b20000",
  },
  topicContainer: {
    height: hp("6.5%"),
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
    marginTop: 2,
    marginBottom: 2,
  },
  topicText: {
    fontSize: GlobalStyles.fontSize.xs,
    fontFamily: GlobalStyles.inpFont.fontFamily,
    textAlign: "center",
    width: "100%",
    flexShrink: 1,
    paddingVertical: 1,
  },
});

export default NFProgress;
